// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:4M262g */\n.mt1__{align-items:center;display:flex;gap:var(--audio-spacing-8)}.I5i0C{align-items:center;display:flex;gap:var(--audio-spacing-8)}.Wrwn3{height:1.25rem;width:1.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": "mt1__",
	"item": "I5i0C",
	"icon": "Wrwn3"
};
export default ___CSS_LOADER_EXPORT___;
